import { FC } from 'react';

import { Badge, Badges } from '../components/Badges';
import { Column, Columns } from '../components/Columns';
import { Content } from '../components/Content';
import { BlockType } from '../constants/BlockType';
import { Block } from '../types/Block';
import { BlockProps } from '../types/BlockProps';

export const BLOCK_TYPE_TO_COMPONENT_MAP: Record<
  BlockType,
  FC<BlockProps<Block>>
> = {
  [BlockType.Content]: Content,
  [BlockType.Columns]: Columns,
  [BlockType.Column]: Column,
  [BlockType.Badges]: Badges,
  [BlockType.Badge]: Badge,
};
